'use es6';

import { connect } from 'react-redux';
import { isEmpty } from 'underscore';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { addValidationErrorIfNeeded, removeValidationErrorIfNeeded, toggleStyleSidePanel as toggleStyleSidePanelAction } from 'FormsUI/actions/FormDefinition';
import { selectStyleOptions as selectStyleOptionsAction } from 'FormsUI/actions/Tours';
import { ValidationKeys, ValidationType } from 'FormsUI/constants/FormFieldValidations';
import AppLink from 'FormsUI/components/common/AppLink';
import ConfigurationPanelHeader from 'FormsUI/components/editor/form/configuration/ConfigurationPanelHeader';
import { getV2EditorRoute } from 'FormsUI/lib/RouteGenerators';
import { getSubmitText, getSubmitLabelValidation, getIsRenderRawHtmlEnabled } from 'FormsUI/selectors/FormDefinition';
import { hasCustomStyleAccess as hasCustomStyleAccessFromSelector } from 'FormsUI/selectors/Scope';
import { updateOptionsPanelNavigationItem } from 'FormsUI/actions/OptionsPanelNavigationItems';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import SubmitButtonPaymentSectionContainer from 'FormsUI/components/editor/form/configuration/submitButtonConfigurationPanel/SubmitButtonPaymentSectionContainer';
import { ConfigPanelWrapper } from 'FormsUI/components/editor/form/configuration/ConfigPanelWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const handleUpdate = ({
  value,
  update,
  addValidationError,
  removeValidationError
}) => {
  if (isEmpty(value)) {
    addValidationError('form', ValidationKeys.SUBMIT_LABEL, ValidationType.REQUIRED);
  } else {
    removeValidationError('form', ValidationKeys.SUBMIT_LABEL, ValidationType.REQUIRED);
  }
  update({
    submitText: value
  });
};
export const StyleSettingsSection = ({
  toggleStyleSidePanel,
  selectStyleOptions,
  isRenderRawHtmlEnabled,
  formGuid
}) => /*#__PURE__*/_jsx(Text, {
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `editor.form.config.changeColorsAndFonts`,
    options: {
      styleAndPreview: /*#__PURE__*/_jsx(AppLink, {
        disabled: isRenderRawHtmlEnabled,
        "data-test-id": "form-row__name-link",
        href: getV2EditorRoute(formGuid, 'test'),
        onClick: () => {
          toggleStyleSidePanel('theme');
          toggleStyleSidePanel('style');
          selectStyleOptions(formGuid);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `editor.form.config.styleAndPreview`
        })
      })
    }
  })
});
const SubmitButtonConfigurationPanel = ({
  submitText = '',
  submitLabelValidation = {},
  update = () => {},
  addValidationError = () => {},
  removeValidationError = () => {},
  hideConfigurationPanel = () => {},
  isRenderRawHtmlEnabled = false,
  selectStyleOptions = () => {},
  formGuid = '',
  isThemeOpen = false,
  isStyleOpen = false,
  toggleStyleSidePanel = () => {},
  hasCustomStyleAccess = false
}) => /*#__PURE__*/_jsxs(ConfigPanelWrapper, {
  "data-commenting-scroll-container": true,
  children: [/*#__PURE__*/_jsx(ConfigurationPanelHeader, {
    handleDone: hideConfigurationPanel
  }), /*#__PURE__*/_jsxs(View, {
    padding: "600",
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlockStart: "1200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `editor.form.config.configForSubmitButton`
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `editor.form.config.label`
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `editor.form.config.labelToolTip`
        }),
        tooltipPlacement: "top right",
        error: !isEmpty(submitLabelValidation),
        validationMessage: !isEmpty(submitLabelValidation) ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: submitLabelValidation.key
        }) : null,
        help: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'editor.options.required'
        }),
        children: /*#__PURE__*/_jsx(TextInput, {
          defaultValue: submitText,
          use: "on-dark",
          "data-test-id": "submit-button-label-input",
          onChange: e => {
            handleUpdate({
              value: e.target.value,
              update,
              addValidationError,
              removeValidationError
            });
          }
        })
      })
    }), /*#__PURE__*/_jsx(SubmitButtonPaymentSectionContainer, {}), hasCustomStyleAccess ? /*#__PURE__*/_jsx(StyleSettingsSection, {
      isRenderRawHtmlEnabled: isRenderRawHtmlEnabled,
      formGuid: formGuid,
      selectStyleOptions: selectStyleOptions,
      isThemeOpen: isThemeOpen,
      isStyleOpen: isStyleOpen,
      toggleStyleSidePanel: toggleStyleSidePanel
    }) : null]
  })]
});
const mapStateToProps = state => ({
  submitText: getSubmitText(state),
  submitLabelValidation: getSubmitLabelValidation(state),
  hasCustomStyleAccess: hasCustomStyleAccessFromSelector(state),
  isRenderRawHtmlEnabled: getIsRenderRawHtmlEnabled(state)
});
const actionCreators = {
  addValidationError: addValidationErrorIfNeeded,
  removeValidationError: removeValidationErrorIfNeeded,
  selectStyleOptions: selectStyleOptionsAction,
  toggleStyleSidePanel: toggleStyleSidePanelAction,
  setActiveNavItem: updateOptionsPanelNavigationItem
};
export default connect(mapStateToProps, actionCreators)(SubmitButtonConfigurationPanel);